import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  balanceFetched: false,
  balance: {
    balance: '0',
    vat: '0'
  },
  transactions: {
    data: [],
    total: 0
  },
  orderSummary: {
    total: 0
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
